import api from './api';

/**
 * SCAC Empty Locations — batch fetch + append + options for the bespoke drawer.
 * cms.scacemptylocations is append-only and grouped into effective-date batches
 * (dateindex = TO_DAYS(effectivedatetime)); the main list uses the generic /tablemaint
 * engine (key 'scacempty') and the Deleted flag is toggled via the engine's update.
 */
export interface ScacEmptyOptions {
  scacs: { value: string; label: string }[];
  terminals: string[];
  pools: string[];
}

export interface ScacEmptyBatchRow {
  recno: number;
  scac: string;
  terminal: string;
  chassisprovider: string;
  size: string;
  equiptype: string;
  pickuplocation: number;
  terminatelocation: number;
  deleted: string;
  effectivedatetime: string;  // 'MM/DD/YYYY HH:mm'
  effectivedate: string;      // 'YYYY-MM-DD'
  pickup_lname: string;
  terminate_lname: string;
  /** The referenced location's OWN soft-delete flag ('Y' / ''), so a line pointing at a
   *  since-deleted location reads as deleted rather than looking healthy. */
  pickupdeleted: string;
  terminatedeleted: string;
}

export interface NewEmptyLine {
  scac: string;
  terminal: string;
  chassisprovider: string;
  size: string;
  equiptype: string;
  pickuplocation: number;
  terminatelocation: number;
}

export async function getScacEmptyFormOptions(): Promise<ScacEmptyOptions> {
  const res = await api.get('/scacempty/form-options');
  return res.data as ScacEmptyOptions;
}

export async function getScacEmptyBatch(dateindex: number): Promise<ScacEmptyBatchRow[]> {
  const res = await api.get('/scacempty/batch', { params: { dateindex } });
  return res.data as ScacEmptyBatchRow[];
}

export async function addScacEmptyLines(effectivedate: string, lines: NewEmptyLine[]): Promise<{ inserted: number }> {
  const res = await api.post('/scacempty/add', { effectivedate, lines });
  return res.data as { inserted: number };
}
